import { z } from 'zod';
import { Tag } from './tag.js';
export const TagResponse = z.object({ tag: Tag });
export const TagListResponse = z.object({ tags: z.array(Tag) });
//# sourceMappingURL=responses.js.map